<div class="selected-user">
  <div class="col-4 no-r-m">
    <div class="profile-holder">
      <img class="profile-pic" src="{{ profilePicUrl }}" alt />
    </div>
  </div>
  <div class="col-8 no-l-m">
    <div class="col-12 no-l-m no-r-m">
      <div
        class="selection-index"
        [ngClass]="{ 'hidden-panel': totalNumberOfUsers < 2 }">
        <span>{{ currentIndex + 1 }} of {{ totalNumberOfUsers }}</span>
      </div>
      <h3 class="username">{{ user.first_name }} {{ user.name }}</h3>
      <div class="actions">
        <button class="btn btn-primary" (click)="directMsg()">
          Send a Message
        </button>
      </div>
      <br />
    </div>

    <div class="col-6 no-l-m no-r-m" *ngIf="user.organization">
      <label class="form-label" for="">Organization</label>
      <div class="val">{{ user.organization }}</div>
    </div>
    <div class="col-6 no-l-m no-r-m" *ngIf="hasDepartment">
      <label class="form-label" for="">Department</label>
      <div class="val">{{ user.department }}</div>
    </div>
    <div *ngIf="hasOccupation" class="col-6 no-l-m no-r-m">
      <label class="form-label" for="">Occupation</label>
      <div class="val">{{ user.occupation }}</div>
    </div>

    <ng-container *ngIf="hasContactInfo">
      <div class="col-6 no-l-m no-r-m" *ngIf="hasEmail">
        <label class="form-label" for="">Email</label>
        <div class="val">{{ user.email }}</div>
      </div>

      <ng-container *ngIf="hasLocation">
        <div class="col-6 no-l-m no-r-m" *ngIf="user.location.zipcode">
          <label class="form-label" for="">Zip Code</label>
          <div class="val">{{ user.location.zipcode }}</div>
        </div>
        <div class="col-6 no-l-m no-r-m" *ngIf="user.location.city">
          <label class="form-label" for="">City</label>
          <div class="val">{{ user.location.city }}</div>
        </div>
        <div class="col-6 no-l-m no-r-m" *ngIf="user.location.country">
          <label class="form-label" for="">Country</label>
          <div class="val">{{ user.location.country }}</div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
